import './ProductList.scss';

import cn from 'classnames';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';

import BackMenuButton from '@/ebat/components/blocks/Header/BackMenuButton/BackMenuButton';

// eslint-disable-next-line import/no-cycle
import ProductItem from '../ProductItem/ProductItem';
import {
  ProductListDefaultProps,
  ProductListPropTypes,
} from './ProductList.proptypes';

const ProductList = ({
  className,
  items,
  selectedItem,
  parent,
  panelWidth,
  panelIndex,
  onSelect,
  isOpen,
  isRoot,
}) => {
  const ref = useRef();
  const { t } = useTranslation();

  const panelStyle = {};
  if (panelWidth !== null) {
    panelStyle.width = panelWidth;
    panelStyle.left = panelWidth * panelIndex;
  }

  return (
    <CSSTransition
      classNames="product-menu-list--transition"
      timeout={300}
      nodeRef={ref}
      in={isOpen}
      mountOnEnter
      unmountOnExit
      appear
    >
      <div
        className={cn(
          className,
          'product-menu-list',
          `product-menu-list--panel-${panelIndex}`,
          {
            'product-menu-list--root': isRoot,
          },
        )}
        data-qa-id="product-menu-list"
        ref={ref}
        style={panelStyle}
      >
        <BackMenuButton
          label={parent ? parent.name : t('common:entities:product.label')}
          onClick={() => onSelect(parent?.parent)}
        />
        <ul
          className="product-menu-list__list"
          data-qa-id="product-menu-list-list"
        >
          {items.map((item) => (
            <ProductItem
              key={item.id}
              item={item}
              selectedItem={selectedItem}
              onSelect={onSelect}
            />
          ))}
          {parent && parent.depth > 1 && (
            <ProductItem
              className="product-menu-item--see-all"
              item={{
                children: [],
                depth: parent.depth + 1,
                id: `${parent.id}-all`,
                image: null,
                isLeaf: true,
                name:
                  parent.depth > 1
                    ? t('common:entities:product.see_all_products')
                    : t('common:entities:product.see_all'),
                path: parent.path,
              }}
              selectedItem={selectedItem}
              onSelect={onSelect}
            />
          )}
        </ul>
      </div>
    </CSSTransition>
  );
};

ProductList.defaultProps = {
  ...ProductListDefaultProps,
};

ProductList.propTypes = {
  ...ProductListPropTypes,
};

export default ProductList;
